import axios from '@/libs/api.request'

export const getEquipmentList = (params) => {
  return axios.request({ url: '/m_api/equipment/list', method: 'get', params })
}
export const approveEquipment = (data) => {
  return axios.request({ url: '/m_api/equipment/approve', method: 'post', data })
}
export const rejectEquipment = (data) => {
  return axios.request({ url: '/m_api/equipment/reject', method: 'post', data })
}
export const updateEquipmentStatus = (data) => {
  return axios.request({ url: '/m_api/equipment/status', method: 'post', data })
}
export const deleteEquipment = (data) => {
  return axios.request({ url: '/m_api/equipment/delete', method: 'post', data })
}
export const editEquipment = (data) => {
  return axios.request({ url: '/m_api/equipment/edit', method: 'put', data })
}
// 参数包相关 — 设备端 tv_tw 设置页使用
export const getEquipmentParam = (sn) => {
  return axios.request({ url: '/m_api/equipment/param', method: 'get', params: { Sn: sn } })
}
export const uploadEquipmentParam = (data) => {
  return axios.request({ url: '/m_api/equipment/param/upload', method: 'post', data })
}